export default __webpack_public_path__ + "img/clicked-link.88b519dd.svg";